/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Lightweight reference to an add-on the org is currently subscribed to.
 */
export interface SubscriptionAddonRef {
  id: string;
  slug: string;
  name: string;
  status: string;
}
